import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import "./CreditCustomer.css";
import { PrettoSlider } from "../../collectionUtils";

interface CreditCustomerProps {
  isOpen: boolean;
  onToggle: () => void;
  utilizedCredit: number;
  creditLimit: number;
  availableLimit: number;
  currentOutstanding: number;
}

const CreditCustomer: React.FC<CreditCustomerProps> = ({
  isOpen,
  onToggle,
  utilizedCredit,
  creditLimit,
  availableLimit,
  currentOutstanding,
}) => {
  const formatCurrency = (amount: number): string => {
    return `₹${amount.toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };

  return (
    <div className="credit-customer-card">
      <div className="credit-customer-header" onClick={onToggle}>
        <span className="credit-customer-title">Credit Customer</span>
        <ArrowDropDownIcon
          sx={{
            color: "#6E6969",
            transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.2s ease",
          }}
        />
      </div>
      {isOpen && (
        <div className="credit-customer-content">
          <div className="credit-customer-left">
            <div className="credit-customer-left-row">
              <span className="credit-customer-label">Utilised Credit</span>
              <span className="credit-limit-label">Credit Limit</span>
            </div>
            <PrettoSlider
              valueLabelDisplay="auto"
              aria-label="credit slider"
              value={(utilizedCredit / creditLimit) * 100}
              sx={{
                padding: "8px 0 6px 0",
              }}
              disabled={true}
            />
            <div className="credit-customer-left-row">
              <span className="utilised-credit-amount">{formatCurrency(utilizedCredit)}</span>
              <span className="credit-limit-amount">{formatCurrency(creditLimit)}</span>
            </div>
          </div>
          <div className="credit-customer-right">
            <div className="credit-info-box" style={{ backgroundColor: `${(availableLimit > 0) ? "#F0FBFF" : "#FFF2F2"}` }}>
              <span className="credit-info-label">Available Limit</span>
              <span className="credit-info-value" style={{ color: `${(availableLimit > 0) ? "#17B4A3" : "#D84C59"}` }}>
                {formatCurrency(availableLimit)}
              </span>
            </div>
            <div className="credit-info-box" style={{ backgroundColor: "#FFF2F2" }}>
              <span className="credit-info-label">Current Outstanding</span>
              <span className="credit-info-value" style={{ color: "#D84C59" }}>
                {formatCurrency(currentOutstanding)}
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CreditCustomer;